(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delivery-estimate')) {
    customElements.define(
      'delivery-estimate',
      class DeliveryEstimate extends HTMLElement {
        connectedCallback() {
          const minimumDays = Math.max(1, Number(this.dataset.minDays) || 5);
          const maximumDays = Math.max(minimumDays, Number(this.dataset.maxDays) || 7);
          const locale = this.dataset.locale || document.documentElement.lang || 'en';
          const formatter = new Intl.DateTimeFormat(locale, {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
          });

          const addBusinessDays = (days) => {
            const date = new Date();
            date.setHours(12, 0, 0, 0);
            let addedDays = 0;

            while (addedDays < days) {
              date.setDate(date.getDate() + 1);
              const weekday = date.getDay();
              if (weekday !== 0 && weekday !== 6) addedDays += 1;
            }

            return date;
          };

          const updateDate = (selector, date) => {
            const element = this.querySelector(selector);
            if (!element) return;
            element.textContent = formatter.format(date);
            element.dateTime = date.toISOString().slice(0, 10);
          };

          updateDate('[data-delivery-start]', addBusinessDays(minimumDays));
          updateDate('[data-delivery-end]', addBusinessDays(maximumDays));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-upsell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pdp-upsell')) {
    customElements.define(
      'pdp-upsell',
      class PdpUpsell extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', (event) => {
            const button = event.target.closest('[data-variant-id]');
            if (button && !button.disabled) this.addToCart(button);
          });
        }

        async addToCart(button) {
          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const label = button.querySelector('[data-upsell-label]');
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData();
          formData.append('id', button.dataset.variantId);
          formData.append('quantity', 1);
          if (cart) {
            formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
            cart.setActiveElement(button);
          }
          config.body = formData;

          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          label.textContent = this.dataset.addingText;

          try {
            const response = await fetch(`${routes.cart_add_url}`, config).then((res) => res.json());
            if (response.status) throw new Error(response.description || response.message);

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'pdp-upsell',
              productVariantId: button.dataset.variantId,
              cartData: response,
            });
            if (cart) {
              cart.classList.remove('is-empty');
              cart.renderContents(response);
            }
            label.textContent = this.dataset.addedText;
            button.classList.add('is-added');
          } catch (error) {
            console.error(error);
            label.textContent = this.dataset.addText;
            button.disabled = false;
          } finally {
            button.removeAttribute('aria-busy');
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
